export default "https://cdn-static.gokick.com/assets/d6a1d1f7abc93216fd07fb40adb7adf28904b072/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";